import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const InviteRedirectHandler = () => {
  const { token } = useAuth();
  const navigate = useNavigate();
  const { inviteId } = useParams();

  useEffect(() => {
    if (token) {
      navigate("/requests", { replace: true });
    } else {
      navigate(`/login?redirect=/requests&invite=${inviteId}`, {
        replace: true,
      });
    }
  }, [token, navigate, inviteId]);

  return <div>Loading...</div>;
};

export default InviteRedirectHandler;
